import { Fragment } from 'react';
import { SignInPageBlueprint, SignInPageProps } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import {
  configApiRef,
  oktaAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import {
  BackendHealthIndicator,
  BackendHealthStatusProvider,
} from '../../components/BackendHealthStatusContext';

export const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => {
      const SignInPageWithProviders = (props: SignInPageProps) => {
        const configApi = useApi(configApiRef);
        const baseUrl = configApi.getOptionalString('app.baseUrl') ?? '';
        const isLocal = baseUrl.includes('localhost');
        const providers = [
          ...(isLocal ? (['guest'] as const) : []),
          {
            id: 'okta-auth-provider',
            title: 'Okta',
            message: 'Sign in using Okta',
            apiRef: oktaAuthApiRef,
          },
        ];
        // Unauthenticated: app `AppRootWrapper` children never mount, so root health UI is duplicated here for the login screen.
        return (
          <BackendHealthStatusProvider>
            <Fragment>
              <SignInPage {...props} auto providers={providers} />
              <BackendHealthIndicator />
            </Fragment>
          </BackendHealthStatusProvider>
        );
      };
      return SignInPageWithProviders;
    },
  },
});
